import { Download } from 'lucide-react';
import { usePWAInstall } from '@/hooks/usePWAInstall';

export function PWAInstallButton(): React.ReactElement | null {
  const { canInstall, install } = usePWAInstall();

  if (!canInstall) return null;

  return (
    <button
      type="button"
      onClick={() => void install()}
      className="inline-flex items-center gap-1.5 rounded-md border border-primary/30 bg-primary/10 px-2.5 py-1 text-xs font-medium text-primary hover:bg-primary/20 transition-colors"
      title="Install Metis as an app"
      aria-label="Install Metis as a desktop app"
    >
      <Download className="size-3.5" />
      Install
    </button>
  );
}
